import api from '@pray/shared/utils/api';

type EnhanceImageResponse = {
  url: string;
};

type EnhanceImageProps = {
  artistId: string;
  imageUrl: string;
  aspectRatio: string;
};

export const enhanceImage = async ({ artistId, imageUrl, aspectRatio }: EnhanceImageProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!imageUrl) throw Error('Image URL is required');

  const url = `/web/studio/artists/${artistId}/images/enhance`;
  const response = await api.executePostRequest<{ data: EnhanceImageResponse }>(url, { imageUrl, aspectRatio });
  return response?.data?.data;
};
